<template>
  <app-modal id="modal-apply-model" hide-footer>
    <h4 class="text-center">
      {{ t("In a nutshell:") }}
    </h4>
    <p>
      {{
        t("We work with women worldwide, so wherever you are, if you like what we do and feel like working with us, please send an e-mail to:")
      }}
    </p>
    <p class="email">
      <span class="email-address" />
    </p>
    <p v-html="t('Looking forward to hearing from you. <br /> Your Ersties Team')" />
  </app-modal>
</template>

<script setup lang="ts">
import AppModal from "@/components/v2/modals/modal";
import { useI18n } from "vue-i18n";

defineOptions({
  name: "modal-apply-model",
});
const { t } = useI18n();
</script>

<style lang="scss">
@import "./index";
</style>
